import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useGroupParticipants } from '@/features/chats/viewmodels';
import { formatJidToUserId } from '@/features/chats/utils';
import { Username } from '@/features/users';

function GroupParticipants({ activeChatJid }) {
   const userId = useMemo(() => formatJidToUserId(activeChatJid), [activeChatJid]);

   const { participants } = useGroupParticipants(userId);

   return (
      <span className="chat-message-text">
         {participants.map((p, index) => (
            <span key={p.userId}>
               <Username userId={p.userId} />
               {index < participants.length - 1 ? ', ' : ''}
            </span>
         ))}
      </span>
   );
}

GroupParticipants.propTypes = {
   activeChatJid: PropTypes.string.isRequired,
};

export default GroupParticipants;
